module.exports = {
	"id": "FR",
	"name": "France",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.014108,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.028216,
			"17": null,
			"18": 0.014108,
			"19": null,
			"20": null,
			"21": 0.014108,
			"22": 0.014108,
			"23": 0.021162,
			"24": 0.007054,
			"25": 0.021162,
			"26": 0.007054,
			"27": 0.014108,
			"28": 0.007054,
			"29": 0.091702,
			"30": 0.007054,
			"31": 0.056432,
			"32": 0.014108,
			"33": 0.028216,
			"34": 0.03527,
			"35": 0.049378,
			"36": 0.042324,
			"37": 0.049378,
			"38": 0.056432,
			"39": 0.091702,
			"40": 0.063486,
			"41": 0.077594,
			"42": 0.084648,
			"43": 0.28216,
			"44": 0.10581,
			"45": 0.10581,
			"46": 0.119918,
			"47": 0.119918,
			"48": 0.204566,
			"49": 2.165578,
			"50": 0.296268,
			"51": 1.389638,
			"52": 0.648968,
			"53": 21.860346,
			"54": 5.650254,
			"55": 0.056432,
			"56": 0.021162,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.014108,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.03527,
			"13": null,
			"14": null,
			"15": 0.007054,
			"16": 0.028216,
			"17": 0.021162,
			"18": null,
			"19": 0.007054,
			"20": 0.014108,
			"21": 0.021162,
			"22": 0.007054,
			"23": 0.007054,
			"24": 0.056432,
			"25": 0.007054,
			"26": 0.014108,
			"27": 0.014108,
			"28": 0.014108,
			"29": 0.021162,
			"30": 0.021162,
			"31": 0.126972,
			"32": 0.021162,
			"33": 0.028216,
			"34": 0.056432,
			"35": 0.042324,
			"36": 0.042324,
			"37": 0.03527,
			"38": 0.296268,
			"39": 0.056432,
			"40": 0.049378,
			"41": 0.07054,
			"42": 0.063486,
			"43": 0.268052,
			"44": 0.119918,
			"45": 0.479672,
			"46": 0.253944,
			"47": 1.02283,
			"48": 1.12864,
			"49": 11.787234,
			"50": 0.098756,
			"51": 0.021162,
			"52": 0.007054,
			"3.5": null,
			"3.6": 0.021162
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.014108,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.028216,
			"37": 0.014108,
			"38": 0.21162,
			"39": 0.056432,
			"40": 0.45851,
			"41": 0.063486,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.042324
		},
		"safari": {
			"0": null,
			"4": 0.028216,
			"5": 0.091702,
			"6": 0.021162,
			"7": 0.063486,
			"8": 0.296268,
			"9": 0.437348,
			"10": 2.588818,
			"3.1": null,
			"3.2": null,
			"5.1": 0.232782,
			"6.1": 0.155188,
			"7.1": 0.021162,
			"9.1": 1.982174
		},
		"ios_saf": {
			"8": 0,
			"10": 6.46655830641,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.174266263739,
			"8.1-8.4": 0.321949538093,
			"9.0-9.2": 0.153590605329,
			"9.3": 2.34324128643
		},
		"android": {
			"3": 0,
			"4": 0.0222206046512,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0027775755814,
			"4.1": 0.0801528953488,
			"4.2-4.3": 0.200382238372,
			"4.4": 0.459490360465,
			"4.4.3-4.4.4": 0.463458325581
		},
		"ie": {
			"6": 0.0215066579805,
			"7": 0.0215066579805,
			"8": 0.286755439739,
			"9": 0.336937641694,
			"10": 0.265248781759,
			"11": 5.67058882085,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0132056569358,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000366823803773
		},
		"edge": {
			"12": 0.155188,
			"13": 0.84648,
			"14": 2.440684
		},
		"ie_mob": {
			"10": 0.121989295775,
			"11": 0.496670704225
		},
		"bb": {
			"7": 0.013257,
			"10": null
		},
		"samsung": {
			"0": 3.703122
		},
		"and_uc": {
			"0": 0.568578
		},
		"op_mini": {
			"0": 0.17791751926
		},
		"and_chr": {
			"0": 15.030746
		},
		"and_ff": {
			"0": 0.047136
		}
	},
	"total": 98.057481
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/FR.json
 ** module id = 523
 ** module chunks = 0
 **/